module.exports = __webpack_public_path__ + "img/sophie.3f103bfd.png";